export default function getSwitchStyles(value: boolean) {
  const baseThumbStyle = {
    borderRadius: "50%",
    width: "16px",
    height: "16px",
  };

  const thumbStyle = value
    ? baseThumbStyle
    : {
        ...baseThumbStyle,
        border: "1px solid #9e9e9e",
        bgcolor: "#fafafa",
      };

  const trackStyle = {
    width: "26px",
    height: "10px",
  };

  return { thumbStyle, trackStyle };
}
